import { render, staticRenderFns } from "./SizeGuideDialog.vue?vue&type=template&id=1c5fc860&scoped=true"
import script from "./SizeGuideDialog.vue?vue&type=script&lang=js"
export * from "./SizeGuideDialog.vue?vue&type=script&lang=js"
import style0 from "./SizeGuideDialog.vue?vue&type=style&index=0&id=1c5fc860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5fc860",
  null
  
)

export default component.exports